import React from "react"
import Translation from "../../../global/Translation"

const DisplayMinQuantityMessage = ({ quantity }) => {

    const styles = {
        text: {
            fontWeight: 400,
            fontSize: '10px',
            lineHeight: '16px',
            color: '#20367a',
        },
        container: {
            width: '100%',
            lineHeight: 0,
            textAlign: 'left'
        }
    }

    return quantity && (
        <div style={styles.container}>
            <span style={styles.text}>
                 <Translation
                        id="this_product_has_a_minimum_order_quantity"
                        defaultMessage="This product has a minimum order quantity of {quantity} units."
                        values={{ quantity: quantity }}
                    />
            </span>
        </div>
    )
}

export default DisplayMinQuantityMessage